import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Modal as BaseModal, Width } from '@figure/frontlib-gui';
import { SingleInputSubmit, Color } from '@figure/frontlib-gui/lib/Dashboard';
import { withFormik, Form } from 'formik';

const Modal = styled(BaseModal)`
  padding: 24px;
  text-align: center;

  @media (min-width: ${Width.SM}px) {
    padding: 75px;
  }
`;

const FormContainer = styled.div`
  max-width: 300px;
  margin: auto;
  text-align: left;
`;

const Disclaimer = styled.span`
  display: block;
  color: ${Color.GREY_7};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
`;

const ReferralModal = ({
  values,
  errors,
  touched,
  setFieldValue,
  submitState,
  isOpen,
  handleSubmit,
  serverErrors,
  handleClose,
}) => {
  const [initialErrors, setInitialErrors] = useState({});

  useEffect(() => {
    if (serverErrors.email) setInitialErrors(serverErrors);
  }, [serverErrors]);

  return (
    <Modal size="md" isOpen={isOpen} onClose={handleClose}>
      <h1>Referred by a Figure member?</h1>
      <p>
        Please enter the member’s email. (This is the email address associated with their Figure
        account.) After your loan is approved, both you and your friend will receive a $150 gift
        card.
      </p>
      <Form onSubmit={handleSubmit}>
        <FormContainer>
          <SingleInputSubmit
            id="referral-email"
            label=""
            type="email"
            placeholder="email address"
            value={values.email}
            handleSubmit={handleSubmit}
            errorText={initialErrors.email || (touched.email && errors.email)}
            submitState={submitState}
            onChange={(e) => {
              setInitialErrors({});
              return setFieldValue('email', e.target.value);
            }}
            required
          />
          <Disclaimer>
            For either party to be eligible to receive the $150 gift card, the referred personal
            loan must be funded.
          </Disclaimer>
        </FormContainer>
      </Form>
    </Modal>
  );
};

ReferralModal.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitState: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  serverErrors: PropTypes.object,
};

ReferralModal.defaultProps = {
  serverErrors: {},
};

export default withFormik({
  mapPropsToValues: (props) => ({
    email: props.referrerEmail,
  }),
  validationSchema: () =>
    Yup.object().shape({
      email: Yup.string().required().email('Invalid'),
    }),
  handleSubmit: (data, { props, resetForm, setFieldError }) => {
    if (props.refereeEmail.toLowerCase() === data.email.toLowerCase()) {
      setFieldError('email', 'Self referral is not allowed');
    } else {
      resetForm();
      props.handleSubmit(data);
    }
  },
})(ReferralModal);
